var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91671 10L9.41671 12.5L13.5834 7.50001M3.58337 14.0002V6.00017C3.58337 5.06675 3.58337 4.59969 3.76503 4.24317C3.92482 3.92957 4.1796 3.67479 4.4932 3.515C4.84972 3.33334 5.31678 3.33334 6.2502 3.33334H14.2502C15.1836 3.33334 15.6497 3.33334 16.0062 3.515C16.3198 3.67479 16.5754 3.92957 16.7352 4.24317C16.9167 4.59935 16.9167 5.06584 16.9167 5.99744V14.003C16.9167 14.9346 16.9167 15.4004 16.7352 15.7566C16.5754 16.0702 16.3198 16.3254 16.0062 16.4852C15.65 16.6667 15.1842 16.6667 14.2526 16.6667H6.24747C5.31587 16.6667 4.84938 16.6667 4.4932 16.4852C4.1796 16.3254 3.92482 16.0702 3.76503 15.7566C3.58337 15.4001 3.58337 14.9336 3.58337 14.0002Z",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkboxCheck.04efd34ce6214c0d5a013b91a2aa66ed.svg";
export { ForwardRef as ReactComponent };